module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-lookup",
    staticStyle: {
      "display": "block"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": "",
      "disabled": _vm.disabled,
      "placeholder": _vm.$tx(
        'Please Select',
        'common.select'
      )
    },
    model: {
      value: (_vm.lookupValue.name),
      callback: function($$v) {
        _vm.$set(_vm.lookupValue, "name", $$v)
      },
      expression: "lookupValue.name"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-search",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.showLookupDialog
    },
    slot: "suffix"
  })]), _vm._v(" "), _c('rt-lookup-dialog', {
    ref: "lookupDialog",
    attrs: {
      "entity": _vm.entity,
      "request-url": _vm.dialogRequestUrl,
      "name-field": _vm.nameField,
      "id-field": _vm.idField,
      "display-fields": _vm.dialogDisplayFields,
      "orderby-fields": _vm.dialogOrderbyFields,
      "custom-conditions": _vm.dialogCustomConditions,
      "filter-fields": _vm.dialogFilterFields,
      "return-fields": _vm.dialogReturnFields,
      "dialogCallback": _vm.dialogCallback
    },
    on: {
      "data-selected": _vm.handleDataSelected
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7256ffbc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/newlookup/src/lookup.vue
// module id = 2183
// module chunks = 137